import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

import {
    FL_TITLE,
    FL_WARNING
} from "../../../components/i18n/formLabels";
import {
    PH_TITLE,
    PH_WARNING
} from "../../../components/i18n/placeHolders";
import {LangController} from "../../../components/tabs/langController";

const AybMenuLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder:lang?.showOrder },
            title: '',
            warning: '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_TITLE}</Label>
                    <Input
                        type="text"
                        name="title"
                        placeholder={PH_TITLE}
                        value= { child.title }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_WARNING}</Label>
                    <Input
                        type="textarea"
                        rows="8"
                        name="warning"
                        placeholder={PH_WARNING}
                        value= { child.warning }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default AybMenuLangs
